import { AssignmentTypeEnum, CaseTypeEnum, ExpenseType } from 'api/model';

export const containers = {
  aiTestResults: 'ai-test-results',
};
// eslint-disable-next-line import/prefer-default-export
export const emptyGuid = '00000000-0000-0000-0000-000000000000';

export const NavBarStateKey = 'NavBarState';
export enum NavBarState {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

// Både case vyn och assignments listan, (ms)
export const refreshRate = 10000;
export const pollersErrorModalId = 'poller-error-modal';

export const swedenCenterCoords = {
  latitude: 59.3293,
  longitude: 18.0686,
};
export const userIDsExcemptFromEstimationValidation = [
  254, 1181, 272, 1182, 1571,
];

export const isExcemptFromEstimationValidation = (assigneeId: number) => {
  // if the assignee name is one of ET (id = 254), NT (id = 1181), or Autologik (id = 272), or Nacka Transport (id = 1182) then don't validate
  // hard-coded based on prod db ids. Not ideal, but a simple way to hack it for now.
  return userIDsExcemptFromEstimationValidation.includes(assigneeId);
};

/**
 * List of hard-coded estimated durations for cases based on list from Zäkra (see card 291 for details).
 */
export const hardCodedEstimatedDurations: Partial<
  Record<CaseTypeEnum, Record<string, number>>
> = {
  [CaseTypeEnum.Purchase]: {
    'stockholm-stockholm': 2.75 * 60 * 60 * 1000,
  },
  [CaseTypeEnum.Auction]: {
    'stockholm-stockholm': 2.75 * 60 * 60 * 1000,
  },
};

export const userNamesExcemptFromEstimationValidation = [
  'ET',
  'NT',
  'Autologik',
  'Nacka Transport',
  'Kontoret',
];

export const expectableExpenses = [
  ExpenseType.Gas,
  ExpenseType.CarWash,
  ExpenseType.TireChange,
  ExpenseType.SJTicket,
  ExpenseType.Hotel,
  ExpenseType.FlightTicket,
  ExpenseType.Taxi,
  ExpenseType.SLTicket,
  ExpenseType.BoatTicket,
];

export const personalTransportAssignmentTypes = [
  AssignmentTypeEnum.GoByBoat,
  AssignmentTypeEnum.GoByBus,
  AssignmentTypeEnum.GoByPlane,
  AssignmentTypeEnum.GoByTrain,
  AssignmentTypeEnum.GoByPublicTransport,
  AssignmentTypeEnum.GoByTaxi,
] as AssignmentTypeEnum[];

export const considerHighMileageAbove = 15000;
export const considerOldYearModelAgeYears = 10;

export const maxStandByTimeInHours = 8;

// Driving-policy working-time caps. The real values come from the backend report
// (maxHoursPerWeek / maxHoursPer4Weeks); these are only the fallback used when the report
// omits them, so the progress bars still render sensibly.
export const DEFAULT_MAX_HOURS_PER_WEEK = 48;
export const DEFAULT_MAX_HOURS_PER_4_WEEKS = 192;

export const googleMapsRoutingBaseURL =
  'https://www.google.com/maps/dir/?api=1&origin={origin}&destination={destination}&travelmode=transit';

export const maxKPIDateRangeMs = 60 * 24 * 60 * 60 * 1000;

/**
 * Ledningsrapportens paneler har ett eget, längre tak än övriga nyckeltal.
 *
 * P2 och P7 ÄR årstrender (1/1 → nu), så 60-dagarstaket hade gjort dem omöjliga att visa —
 * panelerna och nedladdningsknappen skulle ha slagit i taket innan året ens var halvvägs.
 * 366 dagar är samma gräns som ExportLogic tillämpar på serversidan, så skärmen och filen
 * säger nej vid exakt samma intervall i stället för att skilja sig åt.
 */
export const maxManagementReportDateRangeMs = 366 * 24 * 60 * 60 * 1000;

export const SWEDISH_COUNTIES = [
  'BLEKINGE',
  'DALARNA',
  'GOTLAND',
  'GÄVLEBORG',
  'HALLAND',
  'JÄMTLAND',
  'JÖNKÖPING',
  'KALMAR',
  'KRONOBERG',
  'NORRBOTTEN',
  'SKÅNE',
  'STOCKHOLM',
  'SÖDERMANLAND',
  'UPPSALA',
  'VÄRMLAND',
  'VÄSTERBOTTEN',
  'VÄSTERNORRLAND',
  'VÄSTMANLAND',
  'VÄSTRA GÖTALAND',
  'ÖREBRO',
  'ÖSTERGÖTLAND',
] as const;
